import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../../shared-components";
import { Typography } from "@wattpad/web-ui-library";
import classNames from "classnames";
import { useTrans } from "../../../hooks";

const Checklist = ({ showHeader }) => {
  const { trans } = useTrans();

  const WHY_JOIN_POINTS = [
    trans("Get personalized story recommendations"),
    trans("Save your favorites to your Library"),
    trans("Comment, vote, and build your community"),
    trans("Write your own story")
  ];

  return (
    <div className={"checklist-container"}>
      {showHeader && (
        <p className={classNames(Typography.LABEL.LARGE, "checklist-title")}>
          {trans("Why join the community?")}
        </p>
      )}
      <ul className={"checklist"}>
        {WHY_JOIN_POINTS.map((text, index) => (
          <li className={"checklist-item"} key={index}>
            <Icon
              name="wpCheck"
              size={24}
              strokeWidth="0"
              fillColor="ds-base-1-accent"
              viewBox={24}
              aria-hidden
            />
            <p
              className={classNames(
                Typography.PARAGRAPH.MEDIUM,
                "checklist-item-text"
              )}
            >
              {text}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

Checklist.propTypes = {
  showHeader: PropTypes.bool
};

export default Checklist;
